
export const titleToSlug = (title) => {
  if (!title) return '';
  
  return title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const encodeTitleForUrl = (title) => {
  if (!title) return '';
  return encodeURIComponent(title);
};

/**
 * Decode title from URL
 * 
 * @param {string} encodedTitle - The URL-encoded title
 * @returns {string} Decoded title
 */
export const decodeTitleFromUrl = (encodedTitle) => {
  if (!encodedTitle) return '';
  try {
    return decodeURIComponent(encodedTitle);
  } catch (error) {
    console.error('Error decoding title from URL:', error);
    return encodedTitle; // Return as-is if decoding fails
  }
};
